import { useEffect } from "react";
import { Link } from "react-router-dom";
import guideBody from "@/content/guideBody";
import FloatingWhatsApp from "@/components/home/FloatingWhatsApp";
import { ArrowLeft } from "lucide-react";

// Guía original "Actívate en MenuThere HOY MISMO" (HTML intacto) con sus scripts originales.
export default function GuidePage() {
  useEffect(() => {
    document.title = "Actívate en MenuThere HOY MISMO — Guía Visual Autodirigida";
    const root = document.querySelector(".guia-page");
    if (!root) return undefined;

    const bar = root.querySelector("#progressBar");
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (bar) bar.style.width = `${(window.scrollY / h) * 100}%`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = root.querySelector(a.getAttribute("href"));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: "smooth", block: "start" }); }
    };
    root.addEventListener("click", onAnchor);

    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.style.opacity = "1"; en.target.style.transform = "translateY(0)"; } });
    }, { threshold: 0.1, rootMargin: "0px 0px -50px 0px" });
    root.querySelectorAll(".fade-in").forEach((el) => {
      el.style.opacity = "0"; el.style.transform = "translateY(20px)"; el.style.transition = "all 0.6s ease"; io.observe(el);
    });

    return () => { window.removeEventListener("scroll", onScroll); root.removeEventListener("click", onAnchor); io.disconnect(); document.title = "MenuThere · Menú digital y pedidos por WhatsApp con 0% de comisión para restaurantes en México"; };
  }, []);

  return (
    <div data-testid="guide-page">
      <div className="bg-brand-carbon text-white text-sm">
        <div className="mt-container flex items-center justify-between py-2.5">
          <Link to="/" className="inline-flex items-center gap-2 hover:text-brand-orange transition-colors font-medium" data-track="guia-volver-home" data-testid="guide-back-link"><ArrowLeft className="w-4 h-4" /> Volver al inicio</Link>
          <span className="hidden sm:block text-gray-400">Guía visual autodirigida · 4 pasos</span>
        </div>
      </div>
      <div className="guia-page" dangerouslySetInnerHTML={{ __html: guideBody }} />
      <FloatingWhatsApp />
    </div>
  );
}
